import React, { forwardRef, useImperativeHandle, useEffect, useMemo } from 'react'
import { Form } from 'antd'
import { Input, Switch } from '@/ui'

import { isPhone } from '@/utils/validate'
import Uploader, { uploadingValidator } from '@/components/Uploader'

const formItemLayout = {
    labelCol: {
        span: 4
    },
    wrapperCol: {
        span: 19
    }
}

const IMAGE_SIZE = 3

const createFields = ({ formType }) => [
    {
        name: 'id',
        component: Input,
        options: {
            hidden: true
        },
        props: {}
    },
    {
        name: 'fullName',
        label: '姓名',
        component: Input,
        options: {
            rules: [
                {
                    required: true,
                    message: '请输入姓名'
                }
            ]
        },
        props: {
            disabled: formType === 'edit'
        }
    },
    {
        name: 'phone',
        label: '手机号码',
        component: Input,
        options: {
            rules: [
                {
                    validator(rule, value) {
                        if (value && !isPhone(value)) {
                            return Promise.reject(new Error('请填写正确手机号码'))
                        }

                        return Promise.resolve()
                    }
                }
            ]
        },
        props: {}
    },
    {
        name: 'headPicture',
        label: '头像',
        component: Uploader.Single,
        options: {
            validateFirst: true,
            rules: [
                {
                    validator(rule, value) {
                        if (typeof IMAGE_SIZE === 'number' && value) {
                            if (value.size > IMAGE_SIZE * 1024 * 1024) {
                                return Promise.reject(new Error(`大小${IMAGE_SIZE}M以内`))
                            }
                        }
                        return Promise.resolve()
                    }
                },
                uploadingValidator
            ]
        },
        props: {}
    },
    {
        name: 'qqNum',
        label: 'QQ',
        component: Input,
        options: {
            rules: []
        },
        props: {}
    },
    {
        name: 'weixinNum',
        label: '微信',
        component: Input,
        options: {
            rules: []
        },
        props: {}
    },
    {
        name: 'qrCode',
        label: '企微二维码',
        component: Uploader.Single,
        options: {
            validateFirst: true,
            rules: [
                {
                    validator(rule, value) {
                        if (typeof IMAGE_SIZE === 'number' && value) {
                            if (value.size > IMAGE_SIZE * 1024 * 1024) {
                                return Promise.reject(new Error(`大小${IMAGE_SIZE}M以内`))
                            }
                        }
                        return Promise.resolve()
                    }
                },
                uploadingValidator
            ]
        },
        props: {}
    },

    // {
    //     name: 'remark',
    //     label: '岗位',
    //     component: Select,
    //     props: {
    //         style: {
    //             width: '150px'
    //         },
    //         placeholder: '选择岗位',
    //         options: jobs_options
    //     },
    //     options: {
    //         rules: [
    //             {
    //                 required: true,
    //                 message: '请选择岗位'
    //             }
    //         ]
    //     }
    // },
    {
        name: 'disabled',
        label: '启用',
        component: Switch,
        options: {
            valuePropName: 'checked'
        }
    }
]

export default forwardRef(({ formType, initialValues, ...restProps }, ref) => {
    const [form] = Form.useForm()

    useEffect(() => {
        form.resetFields()
    }, [initialValues])

    const fields = useMemo(() => {
        return createFields({ formType })
    }, [formType])

    useImperativeHandle(ref, () => form)

    return (
        <Form form={form} initialValues={initialValues} {...restProps}>
            {fields.map(item => (
                <Form.Item key={item.name} name={item.name} label={item.label} {...formItemLayout} {...item.options}>
                    <item.component form={form} {...item.props} />
                </Form.Item>
            ))}
        </Form>
    )
})
